const translations = {
  en: {
    translation: {
      'Incorrect password, please verify or reset your password!': 'Incorrect password, please verify or reset your password !',
      'No user found with this email!': 'No user found with this email !',
      '"email" must be a valid email': 'Please insert a valid email.',
      'Sign in': 'Sign in',
      'Sign in to access the CRM': 'Sign in to access the CRM',
      Email: 'Email',
      Password: 'Password',
      'Log in': 'Log in',
      'Signing in…': 'Signing in…',
      'Show password': 'Show password',
      'Hide password': 'Hide password',
      'Your session has expired, please log in again.': 'Your session has expired, please log in again.',
      'Unable to log in. Please check your connection and try again.': 'Unable to log in. Please check your connection and try again.',
    },
  },
  fr: {
    translation: {
      'Incorrect password, please verify or reset your password!': 'Mot de passe incorrect !',
      'No user found with this email!': 'Aucun utilisateur trouvé avec cet e-mail !',
      '"email" must be a valid email': 'Merci de saisir un e-mail valide !',
      'Sign in': 'Connexion',
      'Sign in to access the CRM': 'Connectez-vous pour accéder au CRM',
      Email: 'Email',
      Password: 'Mot de passe',
      'Log in': 'Se connecter',
      'Signing in…': 'Connexion en cours…',
      'Show password': 'Afficher le mot de passe',
      'Hide password': 'Masquer le mot de passe',
      'Your session has expired, please log in again.': 'Votre session a expiré, veuillez vous reconnecter.',
      'Unable to log in. Please check your connection and try again.': 'Connexion impossible. Vérifiez votre réseau et réessayez.',
    },
  },
};

export {
  translations,
};
